import React from 'react';
import Money from '../../../../components/Money';
import Translate from '../../../../components/Translate';

var MethodMinMax = function MethodMinMax(_ref) {
  var method = _ref.method,
      currency = _ref.currency,
      minDepositBonusAmount = _ref.minDepositBonusAmount,
      remainingDepositLimit = _ref.remainingDepositLimit,
      spainRemainingDepositAmount = _ref.spainRemainingDepositAmount;

  var min = minDepositBonusAmount || method.limit.min;
  var max = remainingDepositLimit !== false && remainingDepositLimit < method.limit.max ? remainingDepositLimit : method.limit.max;
  max = spainRemainingDepositAmount !== false && spainRemainingDepositAmount < max ? spainRemainingDepositAmount : max;
  min = Number(min);
  max = Number(max);

  if (min > max) max = min;

  return React.createElement(
    'div',
    { className: 'method-limit' },
    React.createElement(
      'span',
      { className: minDepositBonusAmount && 'bonus-min' },
      React.createElement(Translate, {
        id: 'noun.min_limit',
        values: {
          limit: React.createElement(Money, {
            value: min,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            currency: currency
          })
        }
      })
    ),
    ' ',
    React.createElement(Translate, {
      id: 'noun.max_limit',
      values: {
        limit: React.createElement(Money, {
          value: max,
          minimumFractionDigits: method.limit.max % 1 === 0 ? 0 : 2,
          maximumFractionDigits: method.limit.max % 1 === 0 ? 0 : 2,
          currency: currency
        })
      }
    })
  );
};

export default MethodMinMax;